// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Championship Events Tab */
.championship-events-tab {
  max-width: 1400px;
}

.events-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.events-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #f1f5f9;
}

.add-event-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #3b82f6;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.add-event-button:hover {
  background: #2563eb;
}

.event-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.event-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #334155;
}

.event-card-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #f1f5f9;
  display: flex;
  align-items: center;
  gap: 8px;
}

.event-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.rounds-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.rounds-selector label {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

.rounds-selector select {
  padding: 6px 10px;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #f1f5f9;
  font-size: 14px;
}

.remove-event-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: transparent;
  border: 1px solid #dc2626;
  border-radius: 6px;
  color: #dc2626;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.remove-event-button:hover {
  background: #dc2626;
  color: white;
}

.round-card {
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
}

.round-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #334155;
  font-size: 14px;
  font-weight: 600;
  color: #f1f5f9;
  display: flex;
  align-items: center;
  gap: 6px;
}

.event-car-selection {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #334155;
}

.event-car-selection h5 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #f1f5f9;
}

.shared-cars-notice {
  margin-top: 24px;
  padding: 16px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 8px;
  color: #94a3b8;
  font-size: 14px;
}

.shared-cars-notice p {
  margin: 0;
}

.shared-cars-notice strong {
  color: #f1f5f9;
}

/* Championship Entry List Tab */
.championship-entrylist-tab {
  max-width: 100%;
  position: relative;
}

.entrylist-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.entrylist-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #f1f5f9;
}

.entrylist-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.view-toggle {
  display: flex;
  gap: 4px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  padding: 4px;
}

.toggle-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.toggle-button:hover {
  color: #f1f5f9;
  background: #334155;
}

.toggle-button.active {
  background: #3b82f6;
  color: white;
}

.save-entrylist-button {
  padding: 10px 16px;
  background: #3b82f6;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.save-entrylist-button:hover {
  background: #2563eb;
}

.entrylist-info {
  padding: 12px 16px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 6px;
  margin-bottom: 20px;
}

.entrylist-info p {
  margin: 0;
  font-size: 14px;
  color: #94a3b8;
}

.entrylist-table-container {
  overflow-x: auto;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
}

/* Mobile: stack each entry row as a card */
@media (max-width: 768px) {
  .entrylist-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .entrylist-actions {
    flex-wrap: wrap;
  }

  .entrylist-table thead {
    display: none;
  }

  .entrylist-table,
  .entrylist-table tbody,
  .entrylist-table tr,
  .entrylist-table td {
    display: block;
    width: 100%;
  }

  .entrylist-table tbody tr {
    border: 1px solid #334155;
    border-radius: 6px;
    margin: 8px;
    padding: 8px 4px;
    background: #0f172a;
    width: calc(100% - 16px);
  }

  .entrylist-table tbody tr.registered-driver {
    border-left: 3px solid #22c55e;
  }

  .entrylist-table td {
    border-bottom: none;
    padding: 6px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .entrylist-table td::before {
    content: attr(data-label);
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    min-width: 90px;
    flex-shrink: 0;
  }

  .table-input.small {
    max-width: none;
  }

  .position-cell {
    text-align: left;
    width: auto;
  }
}

.entrylist-table {
  width: 100%;
  border-collapse: collapse;
}

.entrylist-table thead {
  background: #0f172a;
}

.entrylist-table th {
  padding: 12px 16px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  border-bottom: 1px solid #334155;
}

.entrylist-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #334155;
}

.entrylist-table tbody tr:last-child td {
  border-bottom: none;
}

.entrylist-table tbody tr:hover {
  background: #334155;
}

.entrylist-table tbody tr.registered-driver {
  background: rgba(34, 197, 94, 0.05);
  border-left: 3px solid #22c55e;
}

.entrylist-table tbody tr.registered-driver:hover {
  background: rgba(34, 197, 94, 0.1);
}

.position-cell {
  font-weight: 600;
  color: #94a3b8;
  text-align: center;
  width: 80px;
}

.table-input,
.table-select {
  width: 100%;
  padding: 6px 10px;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #f1f5f9;
  font-size: 13px;
  font-family: inherit;
}

.table-input.small {
  max-width: 100px;
}

.table-input:focus,
.table-select:focus {
  outline: none;
  border-color: #3b82f6;
}

.table-input.cell-error {
  border-color: #dc2626;
  background: rgba(220, 38, 38, 0.08);
}

.table-input.cell-error:focus {
  border-color: #f87171;
}

.championship-entrylist-tab.drag-over {
  outline: 2px dashed #3b82f6;
  outline-offset: -4px;
  background: rgba(59, 130, 246, 0.04);
}

.drop-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: #3b82f6;
  pointer-events: none;
  z-index: 10;
}

.entrylist-json-container {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 16px;
}

.json-editor {
  width: 100%;
  min-height: 500px;
  padding: 16px;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #f1f5f9;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.5;
  resize: vertical;
}

.json-editor:focus {
  outline: none;
  border-color: #3b82f6;
}

.json-format-info {
  margin-top: 16px;
  padding: 12px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 6px;
}

.json-format-info p {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

.json-format-info code {
  padding: 2px 6px;
  background: #0f172a;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #3b82f6;
}

/* Championship Results Tab */
.championship-results-tab {
  max-width: 1200px;
}

.results-summary {
  margin-bottom: 24px;
}

.results-summary h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #f1f5f9;
}

.results-summary p {
  margin: 0;
  font-size: 14px;
  color: #94a3b8;
}

.rounds-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rounds-list .round-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  overflow: hidden;
}

.rounds-list .round-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  text-align: left;
}

.rounds-list .round-header:hover {
  background: #334155;
}

.round-title {
  font-size: 16px;
  font-weight: 600;
  color: #f1f5f9;
  margin-bottom: 4px;
}

.round-subtitle {
  font-size: 13px;
  color: #94a3b8;
}

.rounds-list .round-header svg {
  transition: transform 0.2s;
}

.rounds-list .round-header svg.rotated {
  transform: rotate(180deg);
}

.round-details {
  padding: 0 16px 16px 16px;
}

.session-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
}

.session-card {
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
  padding: 16px;
}

.session-type {
  display: inline-block;
  padding: 4px 8px;
  background: #3b82f6;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.session-name {
  font-size: 15px;
  font-weight: 600;
  color: #f1f5f9;
  margin-bottom: 12px;
}

.session-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #94a3b8;
  margin-bottom: 6px;
}

.session-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.view-session-button,
.delete-session-button {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.view-session-button {
  background: #3b82f6;
  color: white;
}

.view-session-button:hover {
  background: #2563eb;
}

.delete-session-button {
  background: transparent;
  border: 1px solid #dc2626;
  color: #dc2626;
}

.delete-session-button:hover {
  background: #dc2626;
  color: white;
}

.empty-state {
  padding: 32px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
}

.loading,
.error-message {
  padding: 16px;
  text-align: center;
  font-size: 14px;
}

.loading {
  color: #94a3b8;
}

.error-message {
  color: #dc2626;
  background: rgba(220, 38, 38, 0.1);
  border: 1px solid rgba(220, 38, 38, 0.3);
  border-radius: 6px;
}

/* Points system modal */
.points-system-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border: 1px solid #334155;
  border-radius: 10px;
  background-color: #1f2937;
  color: #cbd5e1;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.points-system-button:hover {
  background-color: #334155;
}

.points-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.points-modal {
  width: min(720px, calc(100% - 32px));
  background: #111827;
  border: 1px solid #334155;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.points-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.points-schema-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.points-schema-buttons button {
  border: 1px solid #334155;
  border-radius: 10px;
  background: #1f2937;
  color: #cbd5e1;
  padding: 10px 14px;
  cursor: pointer;
}

.points-schema-buttons button:hover {
  background: #334155;
}

.points-input-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.points-input-row {
  display: grid;
  gap: 8px;
}

.points-input-row label {
  color: #cbd5e1;
  font-size: 13px;
}

.points-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.points-modal-actions button {
  border: 1px solid #334155;
  border-radius: 10px;
  background: #1f2937;
  color: #cbd5e1;
  padding: 10px 14px;
  cursor: pointer;
}

.points-modal-actions button:hover {
  background: #334155;
}

.modal-close-button {
  border: none;
  background: transparent;
  color: #cbd5e1;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChampionshipTabs.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Championship Events Tab */\r\n.championship-events-tab {\r\n  max-width: 1400px;\r\n}\r\n\r\n.events-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.events-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.add-event-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  background: #3b82f6;\r\n  border: none;\r\n  border-radius: 6px;\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.add-event-button:hover {\r\n  background: #2563eb;\r\n}\r\n\r\n.event-card {\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.event-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 16px;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.event-card-header h4 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.event-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.rounds-selector {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 0;\r\n}\r\n\r\n.rounds-selector label {\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n  margin: 0;\r\n}\r\n\r\n.rounds-selector select {\r\n  padding: 6px 10px;\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  color: #f1f5f9;\r\n  font-size: 14px;\r\n}\r\n\r\n.remove-event-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  background: transparent;\r\n  border: 1px solid #dc2626;\r\n  border-radius: 6px;\r\n  color: #dc2626;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.remove-event-button:hover {\r\n  background: #dc2626;\r\n  color: white;\r\n}\r\n\r\n.round-card {\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  padding: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.round-header {\r\n  margin-bottom: 16px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid #334155;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.event-car-selection {\r\n  margin-top: 20px;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #334155;\r\n}\r\n\r\n.event-car-selection h5 {\r\n  margin: 0 0 16px 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.shared-cars-notice {\r\n  margin-top: 24px;\r\n  padding: 16px;\r\n  background: rgba(59, 130, 246, 0.1);\r\n  border: 1px solid rgba(59, 130, 246, 0.3);\r\n  border-radius: 8px;\r\n  color: #94a3b8;\r\n  font-size: 14px;\r\n}\r\n\r\n.shared-cars-notice p {\r\n  margin: 0;\r\n}\r\n\r\n.shared-cars-notice strong {\r\n  color: #f1f5f9;\r\n}\r\n\r\n/* Championship Entry List Tab */\r\n.championship-entrylist-tab {\r\n  max-width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.entrylist-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.entrylist-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.entrylist-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.view-toggle {\r\n  display: flex;\r\n  gap: 4px;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  padding: 4px;\r\n}\r\n\r\n.toggle-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: #94a3b8;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.toggle-button:hover {\r\n  color: #f1f5f9;\r\n  background: #334155;\r\n}\r\n\r\n.toggle-button.active {\r\n  background: #3b82f6;\r\n  color: white;\r\n}\r\n\r\n.save-entrylist-button {\r\n  padding: 10px 16px;\r\n  background: #3b82f6;\r\n  border: none;\r\n  border-radius: 6px;\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.save-entrylist-button:hover {\r\n  background: #2563eb;\r\n}\r\n\r\n.entrylist-info {\r\n  padding: 12px 16px;\r\n  background: rgba(59, 130, 246, 0.1);\r\n  border: 1px solid rgba(59, 130, 246, 0.3);\r\n  border-radius: 6px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.entrylist-info p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.entrylist-table-container {\r\n  overflow-x: auto;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Mobile: stack each entry row as a card */\r\n@media (max-width: 768px) {\r\n  .entrylist-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n  }\r\n\r\n  .entrylist-actions {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .entrylist-table thead {\r\n    display: none;\r\n  }\r\n\r\n  .entrylist-table,\r\n  .entrylist-table tbody,\r\n  .entrylist-table tr,\r\n  .entrylist-table td {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .entrylist-table tbody tr {\r\n    border: 1px solid #334155;\r\n    border-radius: 6px;\r\n    margin: 8px;\r\n    padding: 8px 4px;\r\n    background: #0f172a;\r\n    width: calc(100% - 16px);\r\n  }\r\n\r\n  .entrylist-table tbody tr.registered-driver {\r\n    border-left: 3px solid #22c55e;\r\n  }\r\n\r\n  .entrylist-table td {\r\n    border-bottom: none;\r\n    padding: 6px 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n\r\n  .entrylist-table td::before {\r\n    content: attr(data-label);\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    color: #64748b;\r\n    text-transform: uppercase;\r\n    min-width: 90px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .table-input.small {\r\n    max-width: none;\r\n  }\r\n\r\n  .position-cell {\r\n    text-align: left;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.entrylist-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.entrylist-table thead {\r\n  background: #0f172a;\r\n}\r\n\r\n.entrylist-table th {\r\n  padding: 12px 16px;\r\n  text-align: left;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #94a3b8;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.entrylist-table td {\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.entrylist-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.entrylist-table tbody tr:hover {\r\n  background: #334155;\r\n}\r\n\r\n.entrylist-table tbody tr.registered-driver {\r\n  background: rgba(34, 197, 94, 0.05);\r\n  border-left: 3px solid #22c55e;\r\n}\r\n\r\n.entrylist-table tbody tr.registered-driver:hover {\r\n  background: rgba(34, 197, 94, 0.1);\r\n}\r\n\r\n.position-cell {\r\n  font-weight: 600;\r\n  color: #94a3b8;\r\n  text-align: center;\r\n  width: 80px;\r\n}\r\n\r\n.table-input,\r\n.table-select {\r\n  width: 100%;\r\n  padding: 6px 10px;\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  color: #f1f5f9;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n}\r\n\r\n.table-input.small {\r\n  max-width: 100px;\r\n}\r\n\r\n.table-input:focus,\r\n.table-select:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.table-input.cell-error {\r\n  border-color: #dc2626;\r\n  background: rgba(220, 38, 38, 0.08);\r\n}\r\n\r\n.table-input.cell-error:focus {\r\n  border-color: #f87171;\r\n}\r\n\r\n.championship-entrylist-tab.drag-over {\r\n  outline: 2px dashed #3b82f6;\r\n  outline-offset: -4px;\r\n  background: rgba(59, 130, 246, 0.04);\r\n}\r\n\r\n.drop-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #3b82f6;\r\n  pointer-events: none;\r\n  z-index: 10;\r\n}\r\n\r\n.entrylist-json-container {\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n}\r\n\r\n.json-editor {\r\n  width: 100%;\r\n  min-height: 500px;\r\n  padding: 16px;\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  color: #f1f5f9;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  resize: vertical;\r\n}\r\n\r\n.json-editor:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.json-format-info {\r\n  margin-top: 16px;\r\n  padding: 12px;\r\n  background: rgba(59, 130, 246, 0.1);\r\n  border: 1px solid rgba(59, 130, 246, 0.3);\r\n  border-radius: 6px;\r\n}\r\n\r\n.json-format-info p {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n  line-height: 1.6;\r\n}\r\n\r\n.json-format-info code {\r\n  padding: 2px 6px;\r\n  background: #0f172a;\r\n  border-radius: 3px;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 12px;\r\n  color: #3b82f6;\r\n}\r\n\r\n/* Championship Results Tab */\r\n.championship-results-tab {\r\n  max-width: 1200px;\r\n}\r\n\r\n.results-summary {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.results-summary h3 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.results-summary p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.rounds-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.rounds-list .round-card {\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.rounds-list .round-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 16px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  text-align: left;\r\n}\r\n\r\n.rounds-list .round-header:hover {\r\n  background: #334155;\r\n}\r\n\r\n.round-title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.round-subtitle {\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.rounds-list .round-header svg {\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.rounds-list .round-header svg.rotated {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.round-details {\r\n  padding: 0 16px 16px 16px;\r\n}\r\n\r\n.session-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.session-card {\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  padding: 16px;\r\n}\r\n\r\n.session-type {\r\n  display: inline-block;\r\n  padding: 4px 8px;\r\n  background: #3b82f6;\r\n  color: white;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.session-name {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.session-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.session-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.view-session-button,\r\n.delete-session-button {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.view-session-button {\r\n  background: #3b82f6;\r\n  color: white;\r\n}\r\n\r\n.view-session-button:hover {\r\n  background: #2563eb;\r\n}\r\n\r\n.delete-session-button {\r\n  background: transparent;\r\n  border: 1px solid #dc2626;\r\n  color: #dc2626;\r\n}\r\n\r\n.delete-session-button:hover {\r\n  background: #dc2626;\r\n  color: white;\r\n}\r\n\r\n.empty-state {\r\n  padding: 32px;\r\n  text-align: center;\r\n  color: #94a3b8;\r\n  font-size: 14px;\r\n}\r\n\r\n.loading,\r\n.error-message {\r\n  padding: 16px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.loading {\r\n  color: #94a3b8;\r\n}\r\n\r\n.error-message {\r\n  color: #dc2626;\r\n  background: rgba(220, 38, 38, 0.1);\r\n  border: 1px solid rgba(220, 38, 38, 0.3);\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Points system modal */\r\n.points-system-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 10px 14px;\r\n  border: 1px solid #334155;\r\n  border-radius: 10px;\r\n  background-color: #1f2937;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, color 0.2s;\r\n}\r\n\r\n.points-system-button:hover {\r\n  background-color: #334155;\r\n}\r\n\r\n.points-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.points-modal {\r\n  width: min(720px, calc(100% - 32px));\r\n  background: #111827;\r\n  border: 1px solid #334155;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n.points-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.points-schema-buttons {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.points-schema-buttons button {\r\n  border: 1px solid #334155;\r\n  border-radius: 10px;\r\n  background: #1f2937;\r\n  color: #cbd5e1;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.points-schema-buttons button:hover {\r\n  background: #334155;\r\n}\r\n\r\n.points-input-list {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 12px;\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.points-input-row {\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.points-input-row label {\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n}\r\n\r\n.points-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n}\r\n\r\n.points-modal-actions button {\r\n  border: 1px solid #334155;\r\n  border-radius: 10px;\r\n  background: #1f2937;\r\n  color: #cbd5e1;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.points-modal-actions button:hover {\r\n  background: #334155;\r\n}\r\n\r\n.modal-close-button {\r\n  border: none;\r\n  background: transparent;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
